import PropTypes from 'prop-types';
import React from 'react';
import i18n from 'i18next';

import FlexContainer from 'common/components/atoms/FlexContainer';
import H2 from 'common/typography/H2/H2';
import InputField from 'common/components/atoms/InputField';

import {
  AVG_DAYS_OPTIONS,
  AVG_READINGS_OPTIONS,
  BASE_GRAPH_OPTIONS,
  getAvgDaysOptions,
  getAvgReadingsOptions,
} from '../../../constants/envelope.constants';


const BaseGraphSettings = ({
  settings,
  updateEnvelopeSettings
}) => {
  const avgReadingsOptions = getAvgReadingsOptions(i18n.t.bind(i18n));
  const avgDaysOptions = getAvgDaysOptions(i18n.t.bind(i18n));

  return (
  <FlexContainer marginright="2em" direction="column">
    <H2>{i18n.t('assetHierarchy.envelopeAlarm.baseGraphSettings.title', { defaultValue: 'Base graph' })}</H2>
    <InputField
      disabled={settings.type !== BASE_GRAPH_OPTIONS.AVG_OF_LAST_READINGS}
      label={i18n.t('assetHierarchy.envelopeAlarm.baseGraphSettings.avgOfLast', { defaultValue: 'Avg. of last' })}
      options={avgReadingsOptions}
      onClickSelectable={() => {
        if (settings.type === BASE_GRAPH_OPTIONS.AVG_OF_LAST_READINGS) return;
        updateEnvelopeSettings('base_graph', {
          type: BASE_GRAPH_OPTIONS.AVG_OF_LAST_READINGS,
          value: AVG_READINGS_OPTIONS[0].value
        });
      }}
      onChange={(e, data) => {
        updateEnvelopeSettings('base_graph', {
          ...settings,
          value: data.value
        });
      }}
      prefix={i18n.t('assetHierarchy.envelopeAlarm.baseGraphSettings.readings', { defaultValue: 'readings' })}
      selectable="radio"
      selectableValue={settings.type === BASE_GRAPH_OPTIONS.AVG_OF_LAST_READINGS}
      type="select"
      value={settings.type === BASE_GRAPH_OPTIONS.AVG_OF_LAST_READINGS ? settings.value : ''}
    />
    <InputField
      disabled={settings.type !== BASE_GRAPH_OPTIONS.AVG_OF_LAST_DAYS}
      label={i18n.t('assetHierarchy.envelopeAlarm.baseGraphSettings.avgOfReadingsFromLast', { defaultValue: 'Avg. of readings from the last' })}
      options={avgDaysOptions}
      onClickSelectable={() => {
        if (settings.type === BASE_GRAPH_OPTIONS.AVG_OF_LAST_DAYS) return;
        updateEnvelopeSettings('base_graph', {
          type: BASE_GRAPH_OPTIONS.AVG_OF_LAST_DAYS,
          value: AVG_DAYS_OPTIONS[0].value
        });
      }}
      onChange={(e, data) => {
        updateEnvelopeSettings('base_graph', {
          ...settings,
          value: data.value
        });
      }}
      prefix={i18n.t('assetHierarchy.envelopeAlarm.baseGraphSettings.days', { defaultValue: 'days' })}
      selectable="radio"
      selectableValue={settings.type === BASE_GRAPH_OPTIONS.AVG_OF_LAST_DAYS}
      type="select"
      value={settings.type === BASE_GRAPH_OPTIONS.AVG_OF_LAST_DAYS ? settings.value : ''}
    />
    <InputField
      onChange={() => {
        if (settings.type === BASE_GRAPH_OPTIONS.CURRENTLY_VISIBLE) return;
        updateEnvelopeSettings('base_graph', {
          type: BASE_GRAPH_OPTIONS.CURRENTLY_VISIBLE,
          value: ''
        });
      }}
      title={i18n.t('assetHierarchy.envelopeAlarm.baseGraphSettings.currentlyVisibleReading', { defaultValue: 'The currently visible reading' })}
      type="radio"
      value={settings.type === BASE_GRAPH_OPTIONS.CURRENTLY_VISIBLE}
    />
  </FlexContainer>
  );
};

BaseGraphSettings.propTypes = {
  updateEnvelopeSettings: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired
};


export default BaseGraphSettings;
